// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FiltersMinus: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 11 1" width={width} height={height}>
            <path
                fill="currentColor"
                d="M10.375.5a.38.38 0 0 1-.385.375H.76A.38.38 0 0 1 .375.5C.375.294.548.125.76.125h9.23c.212 0 .385.169.385.375"
            />
        </svg>
    );
};

export default React.memo(FiltersMinus);
